import React from 'react';
import { isMobile } from 'react-device-detect';
import LoginForm from './LoginForm';
import Footer from "../../components/Footer";

const FormCard = () => {
  const Footer = () => (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', maxWidth: 550 }}>
      <div style={{ flex: 1 }}>Privacy Policy</div>
      <div style={{ flex: 1 }}>Terms of Service</div>
      <div style={{ flex: 1 }}>Help</div>
    </div>
  );

  if (isMobile) {
    return (
      <section className="cover cover-page">
        <div
          className="cover-bg-img"
          style={{ backgroundImage: 'url(//cdn.boxpressd.io/placeholder/side-background.jpg)' }}
        />
        <div className="cover-form-container">
          <div className="col-12 col-md-8 col-lg-6 col-xl-4">
            <LoginForm />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="form-card-page form-card row no-gutters" style={{ height: '100vh', margin: 0 }}>
      <div
        className="form-card__img form-card__img--left col-lg-6"
        style={{ backgroundImage: "url('//cdn.boxpressd.io/placeholder/side-background.jpg')", maxWidth: 550, height: '100vh' }}
      />
      <div className="form-card__body col-lg-6 p-5 px-lg-8 d-flex align-items-center">
        <LoginForm />
      </div>
    </section>
  );
};

const Login = () => (
  <div key="1">
    <FormCard />
    {/*<Footer />*/}
  </div>
);

export default Login;
